export default __webpack_public_path__ + "static/media/5.a1c3521b.jpg";